import { render, staticRenderFns } from "./NaturalEntity.vue?vue&type=template&id=cd632790&"
import script from "./NaturalEntity.vue?vue&type=script&lang=js&"
export * from "./NaturalEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd632790')) {
      api.createRecord('cd632790', component.options)
    } else {
      api.reload('cd632790', component.options)
    }
    module.hot.accept("./NaturalEntity.vue?vue&type=template&id=cd632790&", function () {
      api.rerender('cd632790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/NaturalEntity.vue"
export default component.exports